<template>
  <main class="px-4 pt-4">
    <h1 class="mb-4">
      {{ $t('Services') }}
    </h1>
    <dx-data-grid
      ref="servicesGrid"
      :data-source="serviceDataSource"
      :show-column-headers="true"
      :column-min-width="50"
      :column-auto-width="true"
      :allow-column-resizing="true"
      column-resizing-mode="widget"
    >
      <dx-column
        data-field="description"
        :caption="$t('description')"
        :allow-search="false"
      />
      <dx-column
        data-field="description_en"
        :caption="$t('description_en')"
        :allow-search="false"
      />
      <dx-column
        data-field="contact_email"
        :caption="$t('Contact email')"
        :allow-search="true"
      />
      <dx-column
        data-field="transport_kind"
        :caption="$t('transport_kind')"
        :allow-search="false"
        width="250px"
        :customize-text="customizeTransportText"
        edit-cell-template="edit-transport-cell"
      />
      <dx-column
        data-field="shipment_kind"
        :caption="$t('shipment_kind')"
        :allow-search="false"
        width="250px"
        :customize-text="customizeShipmentText"
        edit-cell-template="edit-shipment-cell"
      />
      <dx-column
        data-field="is_shipping"
        :caption="$t('is_shipping')"
        :allow-search="false"
      />
      <dx-column
        data-field="is_port_freight_forwarding"
        :caption="$t('is_port_freight_forwarding')"
        :allow-search="false"
      />
      <dx-column
        data-field="is_transit_decl"
        :caption="$t('is_transit_decl')"
        :allow-search="false"
      />
      <dx-column
        type="buttons"
        :fixed="true"
        :allow-resizing="false"
      />

      <template #edit-transport-cell="{data}">
        <dx-tag-box
          :value="data.data.transport_kind"
          :items="transportTypes"
          display-expr="description"
          value-expr="id"
          @value-changed="data.setValue($event.value)"
        />
      </template>

      <template #edit-shipment-cell="{data}">
        <dx-tag-box
          :value="data.data.shipment_kind"
          :items="shipmentTypes"
          display-expr="description"
          value-expr="id"
          @value-changed="data.setValue($event.value)"
        />
      </template>

      <dx-editing
        :allow-deleting="true"
        :allow-updating="true"
        :allow-adding="true"
        :use-icons="true"
        mode="row"
      />

      <dx-state-storing
        :enabled="true"
        type="localStorage"
        :storage-key="`u${user.id}-service-v2-dictionary`"
      />
    </dx-data-grid>
  </main>
</template>

<script>
import { mapState } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxStateStoring,
} from 'devextreme-vue/data-grid';
import DxTagBox from 'devextreme-vue/tag-box';
import createCustomStore from '@/utils/create-custom-store';

export default {
  name: 'Services',
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxTagBox,
    DxStateStoring,
  },
  data() {
    return {
      serviceDataSource: createCustomStore('service/api/service/'),
      transportTypes: [],
      shipmentTypes: [],
    };
  },
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.getShipmentTypes();
    this.getTransportTypes();
  },
  methods: {
    async getShipmentTypes() {
      const { results } = await this.$http.get('service/api/shipment_kind/');
      this.shipmentTypes = results;
    },
    async getTransportTypes() {
      const { results } = await this.$http.get('service/api/transport_kind/');
      this.transportTypes = results;
    },
    customizeTransportText(cellInfo) {
      if (!cellInfo.value) {
        return '';
      }
      return cellInfo.value.map(it => this.transportTypes.find(({ id }) => it === id).description).join(', ');
    },
    customizeShipmentText(cellInfo) {
      if (!cellInfo.value) {
        return '';
      }
      return cellInfo.value.map(it => this.shipmentTypes.find(({ id }) => it === id).description).join(', ');
    },
  },
};
</script>
